var render = function render(){var _vm=this,_c=_vm._self._c;return _c('prompt',{attrs:{"title":"基本資料修改","label":"請輸入顯示名稱","defaultValue":_vm.displayName,"placeholder":"ex. 王小明"},on:{"confirm":v => _vm.updateProfile({ displayName: v })}})
}
var staticRenderFns = []

export { render, staticRenderFns }